import PageV2 from "components/shared/PageV2";
import { Link } from "react-router-dom";

const SalesOrdersIndexPage = () => {
  const channels = [
    {
      id: "amazon-vendor-central-eu",
      name: "Amazon Vendor Central EU",
      description: "Coming soon.",
    },
    {
      id: "wis-sales-orders",
      name: "WIS Sales Orders",
      description:
        "Create Sales Orders directly in wis, reserve stock, sync to Odoo.",
    },
    {
      id: "shopify-eu",
      name: "Shopify EU",
      description: "View shopify orders, fulfillment status, ALC status.",
    },
    {
      id: "retailer-store",
      name: "Retailer Store",
      description: "Coming soon.",
    },
  ];

  return (
    <PageV2
      testing
      testingMessage="Working in Progress. Please use the original Sales Orders for now. You can check Shopify EU order and ALC fulfillmemt status there tho."
      title="Sales Orders V2"
    >
      <div className="grid grid-cols-3 gap-6">
        {channels.map((channel, index) => (
          <div key={index} className="card">
            <Link to={`${channel.id}`}>
              <h5>{channel.name}</h5>
            </Link>
            {channel.description && (
              <div className="mt-2">{channel.description}</div>
            )}
          </div>
        ))}
      </div>
    </PageV2>
  );
};

export default SalesOrdersIndexPage;
